import { Box, Typography } from "@mui/joy";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { IDettaglio, ILotto } from "../../models";
import SelectLottoGrid from "../list/components/SelectLottoGrid";

interface IlatestListProprs {
  dettagli: IDettaglio[];
}

export default function LatestList({ dettagli }: IlatestListProprs) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const onView = (id: number) => {
    navigate(`../${id}`);
  };
  const lottiToDisplay = useMemo(() => {
    const _lotti: ILotto[] = [];
    dettagli.forEach((dettaglio) => {
      const lotto = dettaglio.lotto;
      if (lotto) {
        const existingLotto = _lotti.find((l) => l.id === lotto.id);
        if (!existingLotto) {
          lotto.dettagli = [dettaglio];
          _lotti.push(lotto);
        } else {
          existingLotto.dettagli?.push(dettaglio);
        }
      }
    });
    _lotti.sort((a, b) => {
      // Caso 1: entrambi hanno dataPubblicazione
      if (b.dataPubblicazione && a.dataPubblicazione) {
        return (
          new Date(b.dataPubblicazione).getTime() -
          new Date(a.dataPubblicazione).getTime()
        );
      }

      // Caso 2: solo uno ha dataPubblicazione → quello con la dataPubblicazione va prima
      if (a.dataPubblicazione && !b.dataPubblicazione) return -1;
      if (!a.dataPubblicazione && b.dataPubblicazione) return 1;

      // Caso 3: nessuno ha dataPubblicazione → ordina per dataCarico
      return (
        new Date(b.dataCarico).getTime() - new Date(a.dataCarico).getTime()
      );
    });
    return _lotti.slice(0, 5);
  }, [dettagli]);
  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          px: "20px",
          height: 64,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: "#36363d",
          "@media screen and (min-width: 1024px)": { px: "50px" },
        }}
      >
        <Box>
          <Typography sx={{}} level="h2">
            {t("LatestArrivals")}
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          px: "20px",
          height: 64,
          display: "flex",
          alignItems: "center",
          "@media screen and (min-width: 1024px)": { px: "50px" },
        }}
      >
        <Typography
          level="body-md"
          sx={{
            cursor: "pointer",
            "&:hover": {
              textDecoration: "underline",
            },
          }}
        ></Typography>
      </Box>
      <Box sx={{ flex: 1, position: "relative" }}>
        <SelectLottoGrid
          lotti={lottiToDisplay}
          onView={onView}
          showMaterialName={true}
        />
      </Box>
    </Box>
  );
}
